import React from 'react';
import '../App.css';

const Partners = () => {
  return (
    <section id="partners" className="py-1">
      <div className="container-fluid" style={{ maxWidth: '1000px' }}>
        {/* <div className="section-header text-center mb-5">
          <h2 className="section-title">Our Partners</h2>
        </div> */}
        <div className="row justify-content-center align-items-center">
          <div className="col-md-4 col-6 text-center d-flex justify-content-center">
            <div className="partner-logo p-3 d-flex flex-column align-items-center">
              <img
                src={`${process.env.PUBLIC_URL}/assets/Anvaya_Logo.png`}
                alt="Anvaya Logo"
                className="img-fluid"
                style={{
                  maxHeight: '150px',
                  width: 'auto',
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                  borderRadius: '8px'
                }}
              />
            </div>
          </div>
          <div className="col-md-4 col-6 text-center d-flex justify-content-center">
            <div className="partner-logo p-3 d-flex flex-column align-items-center">
              <img
                src={`${process.env.PUBLIC_URL}/assets/IIC.jpg`}
                alt="IIC Logo"
                className="img-fluid"
                style={{
                  maxHeight: '150px',
                  width: 'auto',
                  objectFit: 'contain',
                  borderRadius: '50%'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
